import styled from "@emotion/styled";

import { colors } from "../../colors";
import type {
  StyledTabHeaderContainerProps,
  StyledTabHeaderProps,
} from "./types";

export const StyledTabHeaderContainer = styled.div<StyledTabHeaderContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: ${({ $height }) => $height ?? "auto"};
`;

export const StyledTabHeaderTitle = styled.h2<StyledTabHeaderProps>`
  margin: 0;
  padding: 0;
  color: ${({ $titleColor }) => $titleColor ?? colors.gray[800]};
  font-size: 1.4em;
  font-weight: 600;
  line-height: 1.4;
`;

export const StyledTabHeaderDescription = styled.p<StyledTabHeaderProps>`
  margin: 0;
  padding: 0;
  color: ${({ $descriptionColor }) => $descriptionColor ?? colors.gray[500]};
  font-size: 1em;
  line-height: 1.5;
`;
